<template>
  <div class="products-new-revision-view">
    <h1>{{$t('titles.newRevision')}}</h1>
    <loader v-if="isLoading" />
    <div class="products-new-revision-view__forms" v-if="isSuccessfullyLoaded">
      <bundle-product-revision-form
        :errors="errors"
        :product="product"
        @submit="insertRevision"
        v-if="product.bundle"
      />
      <standard-product-revision-form
        :errors="errors"
        :product="product"
        @submit="insertRevision"
        v-else
      />
    </div>
  </div>
</template>

<script>
import BundleProductRevisionForm from '@/components/BundleProductRevisionForm';
import insertBundleProductRevisionMutation
  from '@/api/mutations/insert-bundle-product-revision.graphql';
import insertStandardProductRevisionMutation
  from '@/api/mutations/insert-standard-product-revision.graphql';
import productQuery from '@/api/queries/product.graphql';
import StandardProductRevisionForm
  from '@/components/StandardProductRevisionForm';
import Submittable from '@/mixins/Submittable';
import Toast from '@/helpers/Toast';
import View from '@/mixins/View';

export default {
  name: 'products-new-revision-view',
  mixins: [
    Submittable,
    View,
  ],
  components: {
    BundleProductRevisionForm,
    StandardProductRevisionForm,
  },
  computed: {
    productId() {
      return this.$route.params.productId;
    },
    isSuccessfullyLoaded() {
      return this.isLoaded && this.product;
    },
    breadcrumbs() {
      return [
        {
          key: 'show',
          text: () => this.product.name,
          route: {
            name: 'product',
            params: { id: this.productId },
          },
          isLoading: !this.isSuccessfullyLoaded,
        },
        {
          key: 'newRevision',
          route: {
            name: 'new-product-revision',
            params: { id: this.productId },
          },
        },
      ];
    },
  },
  apollo: {
    product: {
      query: productQuery,
      variables() {
        return { id: this.productId };
      },
      fetchPolicy: 'network-only',
      loadingKey: 'loading',
      update({ product }) {
        return product;
      },
      skip() {
        return !this.isAuthenticated;
      },
    },
  },
  methods: {
    async insertRevision(revision) {
      let mutation;
      if (this.product.bundle) {
        mutation = insertBundleProductRevisionMutation;
      } else {
        mutation = insertStandardProductRevisionMutation;
      }

      const operation = await this.submitWithMutation({
        mutation,
        variables: { productId: this.product.id, revision },
      });

      if (operation.isValid) {
        const name = this.product.name;
        Toast.success(this.$t('toasts.created', { name }));
        this.$router.push({
          name: 'product-revisions',
          params: { id: this.product.id },
        });
      }
    },
  },
  i18n: {
    messages: {
      de: {
        breadcrumbs: {
          newRevision: 'Neue Revision',
        },
        titles: {
          newRevision: 'Revision für Produkt erstellen',
        },
        toasts: {
          created: 'Revision erstellt für {name}',
        },
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// NewRevisionView.vue?6097cdf3